import { render, staticRenderFns } from "./VerifyOwnership.vue?vue&type=template&id=794c6ccc&scoped=true&"
import script from "./VerifyOwnership.vue?vue&type=script&lang=js&"
export * from "./VerifyOwnership.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOwnership.vue?vue&type=style&index=0&id=794c6ccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c6ccc",
  null
  
)

export default component.exports